<template>
  <div class="header">
    <div class="headerbox">
      <div class="logo">
        <img src="../../../public/img/newPages/logo.png" alt="" />
      </div>
      <el-menu
        :default-active="activeIndex"
        class="list"
        background-color="transparent"
        text-color="#fff"
        active-text-color="#fff"
        @select="handleSelect"
      >
        <el-menu-item index="/home">
          <span :class="tabsName == '首页' ? 'select' : ''">首页</span>
        </el-menu-item>
        <el-menu-item
          v-for="(navItem, i) in navList"
          :key="i"
          :index="navItem.title"
          :class="tabsName == navItem.title ? 'select' : ''"
          ><span>{{ navItem.title }}</span></el-menu-item
        >
        <el-menu-item index="/about">
          <span :class="tabsName == '关于我们' ? 'select' : ''">关于我们</span>
        </el-menu-item>
      </el-menu>
      <div class="search">
        <input
          type="text"
          placeholder="请输入关键字"
          v-model="searchText"
          @keyup.enter="searchClick"
        />
        <img
          src="../../../public/img/newPages/sousuo.png"
          alt=""
          @click="searchClick"
        />
        <div class="line"></div>
      </div>
      <div class="xiazai" @click="client()">
        <img src="../../../public/img/newPages/xiazai.png" alt="" />
      </div>
      <div class="touxiang" @click="personal()">
        <img v-if="$store.state.avatar" :src="$store.state.avatar" alt="" />
        <img v-else src="../../../public/img/newPages/touxiang.png" alt="" />
      </div>

      <loginToast
        :status="loginStatus"
        :isClose="changeStatus"
        @resign="resignFn"
      ></loginToast>
      <RegisteredToast
        :state="registeredState"
        :isClose="closeRegisterFn"
        @resign="resignFn"
      ></RegisteredToast>
      <forgetPwd
        :state="fargetState"
        :isClose="forgetFn"
        @resign="resignFn"
      ></forgetPwd>
      <bridge-iframe :login-data="loginData"></bridge-iframe>
    </div>
  </div>
</template>
<script>
import "../../assets/css/newPages.css";
import SearchCom from "@/components/zhangqi/SearchCom.vue";
import loginToast from "@/views/Toast/loginToast.vue";
import RegisteredToast from "../../views/Toast/registeredToast";
import forgetPwd from "../../views/Toast/forgetPwd";
import { getUser } from "../../utils/auth";
import BUS from "../../utils/eventBus";
import bridge from "@/components/bridge.vue";

export default {
  components: {
    SearchCom,
    loginToast,
    RegisteredToast,
    forgetPwd,
    bridgeIframe: bridge,
  },
  props: {
    msg: String,
  },
  data() {
    var that = this;
    this.$axios({
      url: "/realNet/pageManager/getPageManagers",
      method: "get",
      headers: {
        token: "123456789",
      },
    }).then(function (resp) {
      if (resp.data.result && resp.data.result.content) {
        var rmhdItem = null;
        let path = decodeURI(that.$router.currentRoute.fullPath);
        resp.data.result.content.map(function (item, index) {
          if (item.title) {
            switch (item.title) {
              case "RMHD下载":
                rmhdItem = item;
              case "首页":
              case "搜索":
                break;

              default:
                that.navPath[item.title] = item.url;
                that.navList.push(item);
            }
          }

          if (path == "/about") {
            that.tabsName = "关于我们";
          }
          if (item.url == path) {
            that.tabsName = item.title;
          }
        });
        that.navPath[rmhdItem.title] = rmhdItem.url;
        that.navList.push(rmhdItem);
      }
    });
    return {
      activeIndex: "1",
      loginStatus: false,
      registeredState: false,
      fargetState: false,
      clearKey: false,
      navList: [],
      navPath: {},
      loginData: null,
      searchText: "",
      tabsName: "首页",
    };
  },
  watch: {
    clearKey() {
      this.clearKey && (this.searchText = "");
      this.tabsName = "首页";
    },
  },
  methods: {
    searchClick() {
      BUS.$emit("searchEvent", this.searchText);
      this.$emit("resetKey");
      this.$router.push({
        path: "/search",
        query: { searchText: this.searchText },
      });
    },
    personal() {
      if (getUser()) {
        this.$router.push("/mine");
      } else {
        this.loginStatus = true;
      }
      this.clearKey = true;
    },
    client() {
      // this.$router.push("/login");
      window.open("https://resstatic.today365.com.cn/index.html");
    },
    handleSelect(key, keyPath) {
      switch (key) {
        case "/login":
          if (getUser()) {
            this.$router.push("/mine");
          } else {
            this.loginStatus = true;
          }
          this.clearKey = true;
          break;

        case "/":
        case "/home":
          this.$router.push("/");
          // 若监听跳转到此路由，清除用户信息
          if (getUser() != null) {
            let obj = JSON.parse(getUser());
            this.$store.state.name = obj.name;
          }
          this.clearKey = true;
          break;

        case "RMHD下载":
        case "/rmhd":
          if (getUser()) {
            window.location.href =
              "/special-page?pageTitle=RMHD下载&detailPage=DownloadDetailPage";
          } else {
            this.loginStatus = true;
          }
          break;

        case "/about":
          this.$router.push("/about");
          this.tabsName = "关于我们";
          break;

        default:
          if (this.navList.length > 0) {
            window.location.href = this.navPath[key];
          }
      }
    },
    resignFn(params) {
      this.loginData = params;
    },
    loginBtnFn() {
      this.loginStatus = true;
    },
    changeStatus(val) {
      this.loginStatus = false;
      if (val == 1) {
        this.registeredState = true;
      } else if (val == 2) {
        this.fargetState = true;
      }
    },
    closeRegisterFn(val) {
      this.registeredState = false;
      if (val) {
        this.loginStatus = true;
      }
    },
    forgetFn() {
      this.fargetState = false;
    },
  },
  mounted() {
    let obj = getUser();
    if (obj) {
      obj = JSON.parse(obj);
      this.$store.state.name = obj ? obj.name : "";
    }
    var that = this;
    BUS.$on("getUser", (data) => {
      that.$store.state.name = data.name;
    });
    BUS.$on("clearSearchText", () => {
      this.searchText = "";
    });
  },
};
</script>